import { push } from '@lagunovsky/redux-react-router'
import { useFormik } from 'formik'
import Container from 'react-bootstrap/Container'
import { useIntl } from 'react-intl'
import { useDispatch } from 'react-redux'
import * as Yup from 'yup'

import ButtonCinestar from '../../components/Buttons/ButtonCinestar/ButtonCinestar'
import FormLayout from '../../components/Forms/FormLayout/FormLayout'
import InputPhone from '../../components/Inputs/InputPhone/InputPhone'
import Typography from '../../components/Typography/Typography'
import hocThanksForOrder from './hocThanksForOrder'

import { useLocation } from 'react-router'
import useThanksPageGtmInfo from 'services/gtm/useThanksPageGtmInfo'
import './ThanksForOrder.scss'

const extractTickets = (items_tickets) => {
    const ticketList = items_tickets?.reduce((ticketList, ticketObj) => {
        const ticketNumbers = ticketObj.tickets.map((ticket) => ticket.number)
        return [...ticketList, ...ticketNumbers]
    }, [])
    return ticketList
}

const extractVouchers = (items_vouchers) => {
    const voucherNumbers = items_vouchers?.map((voucher) => voucher.number)
    return voucherNumbers
}

const ThanksForOrder = ({ order, sendSms, downloadTicketsAndVouchers }) => {
    const intl = useIntl()
    const dispatch = useDispatch()

    const { search } = useLocation()
    const params = new URLSearchParams(search)
    const paramsObject = Object.fromEntries(params)

    const orderid = paramsObject?.orderid
    const transactionCinemaId = paramsObject?.transactionCinemaId

    useThanksPageGtmInfo(orderid, 'Nákup')

    const formik = useFormik({
        initialValues: {
            phone: '',
        },
        validationSchema: Yup.object({
            phone: Yup.string()
                .matches(/^[1-9][0-9]{2} ?[0-9]{3} ?[0-9]{3}$/, intl.formatMessage({ id: 'forms.register.phoneError' }))
                .required(intl.formatMessage({ id: 'forms.required' })),
        }),
        onSubmit: (values) => {
            const itemsTickets = extractTickets(order.items_tickets)
            const itemsVouchers = extractVouchers(order.items_vouchers)
            const phone = values.phone
            sendSms({ itemsTickets, itemsVouchers, phone, transactionCinemaId })
        },
    })

    const handleDownload = () => {
        const itemsTickets = extractTickets(order.items_tickets)
        const itemsVouchers = extractVouchers(order.items_vouchers)
        downloadTicketsAndVouchers({ itemsTickets, itemsVouchers })
    }

    const haveTickets = order?.items_tickets?.length >= 1
    const haveVouchers = order?.items_vouchers?.length >= 1

    return (
        <Container fluid className={'thanks-for-order d-flex flex-column align-items-center'}>
            <Typography variant={'h1'} className={'me-auto'}>
                {intl.formatMessage({ id: 'thanksForOrder.title' }, { id: orderid })}
            </Typography>

            <FormLayout onSubmit={formik.handleSubmit} color="purple" className={'thanks-for-order--form d-flex w-100'}>
                <div className="thanks-for-order--img position-relative">
                    <img
                        src={'images/cinestar/tickets-blue.png'}
                        alt={'tickets-blue'}
                        className={'position-absolute'}
                    />
                </div>
                {haveTickets || haveVouchers ? (
                    <div className="thanks-for-order--content d-flex flex-column">
                        <Typography variant={'h2'} className={'text-nowrap'}>
                            {intl.formatMessage(
                                { id: 'thanksForOrder.subtitle' },
                                { item: `${haveTickets ? 'Vstupenky' : 'Vouchery'}` }
                            )}
                        </Typography>
                        <Typography variant={'p'}>
                            {intl.formatMessage(
                                { id: 'thanksForOrder.findThem' },
                                {
                                    redirect: (chunks) => (
                                        <u
                                            role={'button'}
                                            className={'text-underline'}
                                            onClick={() => dispatch(push('/user-profile'))}
                                        >
                                            {chunks}
                                        </u>
                                    ),
                                }
                            )}
                        </Typography>
                        <div className="border-top w-100 opacity-50 my-1" />
                        <ButtonCinestar variant={'secondary'} iconLeft={'download'} onClick={() => handleDownload()}>
                            {intl.formatMessage({
                                id: haveTickets ? 'buttons.downloadTickets' : 'buttons.downloadVouchers',
                            })}
                        </ButtonCinestar>

                        {haveTickets && (
                            <div className="thanks-for-order--submit d-flex">
                                <InputPhone
                                    color="purple"
                                    name={'phone'}
                                    id={'phone'}
                                    label={intl.formatMessage({ id: 'thanksForOrder.sendThem' })}
                                    placeholder={intl.formatMessage({ id: 'forms.register.phonePlaceholder' })}
                                    error={formik?.errors?.phone}
                                    touched={formik?.touched?.phone}
                                    onBlur={formik?.handleBlur}
                                    {...formik.getFieldProps('phone')}
                                />
                                <ButtonCinestar variant={'primary-v1'} type={'submit'}>
                                    {intl.formatMessage({ id: 'buttons.send' })}
                                </ButtonCinestar>
                            </div>
                        )}
                    </div>
                ) : (
                    <div className="thanks-for-order--content d-flex flex-column my-5">
                        <Typography variant={'h2'}>{intl.formatMessage({ id: 'thanksForOrder.subtitle2' })}</Typography>
                    </div>
                )}
            </FormLayout>

            <img
                src={'images/cinestar/astronaut-with-mobile.png'}
                alt={'astronaut-with-mobile'}
                className={'astronaut-animate w-50 h-auto mt-10'}
            />
        </Container>
    )
}

export default hocThanksForOrder(ThanksForOrder)
